import React from 'react';
import PropTypes from 'prop-types';

import './spinner.css';

const Spinner = (props) => {
  const {
    isLoading
  } = props;

  const template = isLoading
    ? <span className="glyphicon glyphicon-repeat spinner" />
    : null;

  return template;
};

Spinner.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

export default Spinner;
